import api from "@/configs/axios-config";

export type ManualMasterPartSearchItem = {
  part_number: string;
  part_name: string | null;
  ac: string | null;
  rt: string | null;
  existing_supplier_codes: string[];
};

export type ManualMasterPartListItem = {
  id: number;
  part_number: string;
  part_name: string | null;
  ac: string | null;
  rt: string | null;
  supplier_code: string;
  is_manual: boolean;
  manual_by: string | null;
  manual_date: string | null;
  interface_date: string | null;
};

export type ManualMasterPartListResponse = {
  data: ManualMasterPartListItem[];
  total: number;
  skip: number;
  limit: number;
  has_more: boolean;
};

export type ManualMasterPartListParams = {
  skip: number;
  limit: number;
  search?: string;
};

export type ManualMasterPartPair = {
  part_number: string;
  part_name: string;
  ac: string | null;
  rt: string | null;
  supplier_code: string;
};

export const searchMasterPart = async (
  partNumber: string,
): Promise<ManualMasterPartSearchItem[]> => {
  const response = await api.get("/manual-master-parts/search", {
    params: { part_number: partNumber, limit: 20 },
  });
  return response.data;
};

export const getManualMasterParts = async (
  params: ManualMasterPartListParams,
): Promise<ManualMasterPartListResponse> => {
  const response = await api.get("/manual-master-parts/", { params });
  return response.data;
};

export const bulkCreateManualMasterPart = async (
  pairs: ManualMasterPartPair[],
): Promise<ManualMasterPartListItem[]> => {
  const response = await api.post("/manual-master-parts/bulk", { pairs });
  return response.data;
};

export const deleteManualMasterPart = async (id: number): Promise<void> => {
  await api.delete(`/manual-master-parts/${id}`);
};

export const bulkDeleteManualMasterPart = async (
  ids: number[],
): Promise<void> => {
  await api.post("/manual-master-parts/bulk-delete", { ids });
};
